// Shared, memoised lookup lists needed to turn report data element filter
// IDs (ProcedureID, ClinicID, etc.) into human-readable captions.
// Fetched once regardless of how many rows/components request it.
let promise = null;

export default function loadDataElementLookups(vm) {
	if (!promise) {
		promise = Promise.all([
			vm.$cfetch(`${vm.$settings.APIBaseURL}/reporting/alldata/procedurelist`),
			vm.$cfetch(`${vm.$settings.APIBaseURL}/reporting/alldata/competencytestlist`),
			vm.$cfetch(`${vm.$settings.APIBaseURL}/reporting/alldata/specialtylist`),
			vm.$cfetch(`${vm.$settings.APIBaseURL}/reporting/alldata/cliniclist`),
			vm.$cfetch(`${vm.$settings.APIBaseURL}/forms/listall`),
		])
			.then(([procedures, competencyTests, specialties, clinics, formsResponse]) => ({
				procedures,
				competencyTests,
				specialties,
				clinics,
				forms: formsResponse.results,
			}))
			.catch((error) => {
				promise = null; // allow a retry on the next call
				throw error;
			});
	}
	return promise;
}
